import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setUserPreferencesDisplay, setUserPreferencesTab } from '@/workbench/workbench.actions';
import _ from 'lodash';
import { sqWorksheetStore } from '@/core/core.stores';
import { setTimezone as worksheetActionsSetTimezone } from '@/worksheet/worksheet.actions';
import { Modal } from '@seeqdev/qomponents';
import { PREFERENCE_TABS } from '@/workbench/workbench.store';
import { TimezoneModalContent } from '@/core/TimezoneModal.atom';

interface TimezoneModalProps {
  close: () => void;
  userFallback: boolean;
  onChange?: (timezone?: { name: string }) => void;
}

export const TimezoneModal: React.FunctionComponent<TimezoneModalProps> = ({
  close,
  onChange = _.noop,
  userFallback,
}) => {
  const { t } = useTranslation();

  const [fixed, setFixed] = useState(sqWorksheetStore.timezoneFixed);
  const [timezone, setTimezone] = useState(sqWorksheetStore.timezone);

  const openUserPreferences = () => {
    setUserPreferencesTab(PREFERENCE_TABS.SYSTEM);
    setUserPreferencesDisplay(true);
    close();
  };

  const save = () => {
    if (fixed !== sqWorksheetStore.timezoneFixed || timezone !== sqWorksheetStore.timezone) {
      worksheetActionsSetTimezone(fixed ? timezone : undefined);
      onChange(fixed ? timezone : undefined);
    }
    close();
  };

  return (
    <Modal
      open={true}
      onClose={close}
      size="sm"
      title={t('TIME_ZONE_MODAL.TITLE')}
      cancelButtonLabel={t('CANCEL')}
      submitButtonLabel={t('SAVE')}
      onSubmit={save}>
      <TimezoneModalContent
        userFallback={userFallback}
        fixed={fixed}
        setFixed={setFixed}
        openUserPreferences={openUserPreferences}
        timezone={timezone}
        setTimezone={setTimezone}
      />
    </Modal>
  );
};
